import React from 'react';
import PropTypes from 'prop-types';
import { FlexColumn, FlexRow } from 'web-ui-components/lib/global/layout';
import { connect } from 'react-redux';
import styles from './styles';
import withContent from '../../../containers/withContent';
import { formatSortCode } from '../../../utils/accountUtils';
import tableContent, { contentPropTypes } from '../fps/ImportedPaymentsPage.content';
import { displayDate } from '../../../utils/paymentsImportUtils';
import { getImportedPaymentList } from '../../../states/importedPaymentList/selector';

const mapState = (state) => ({
	paymentDetails: getImportedPaymentList(state),
});

const ImportedPaymentTable = ({
	paymentDetails,
	total,
	content: { toLabel, fromLabel, amountLabel, referenceLabel, dateLabel, totalAmountLabel },
}) => {
	const renderHeader = () => (
		<FlexRow>
			<FlexColumn key="fromLabel" proportion={2}>
				<strong>{fromLabel}</strong>
			</FlexColumn>
			<FlexColumn key="toLabel" proportion={2}>
				<strong>{toLabel}</strong>
			</FlexColumn>
			<FlexColumn key="amountLabel" proportion={1}>
				<strong>{amountLabel}</strong>
			</FlexColumn>
			<FlexColumn key="referenceLabel" proportion={2}>
				<strong>{referenceLabel}</strong>
			</FlexColumn>
			<FlexColumn key="dateLabel" proportion={1}>
				<strong>{dateLabel}</strong>
			</FlexColumn>
		</FlexRow>
	);

	const renderFooter = () => (
		<FlexRow>
			<FlexColumn proportion={4}>
				<strong>{totalAmountLabel}</strong>
			</FlexColumn>
			<FlexColumn proportion={4}>
				<div data-test-id="payment-total">
					<strong>{`£${total}`} </strong>
				</div>
			</FlexColumn>
		</FlexRow>
	);

	const renderBody = (payment) => {
		const {
			from: { displayName, accountNumber, sortCode },
			to,
			amount,
			reference,
			reference_high_value,
			date,
			id,
		} = payment;
		return (
			<FlexRow>
				<FlexColumn key={`from-${id}`} proportion={2}>
					<div className="u-flex-align-items-center">
						{displayName && (
							<div data-test-id="from-displayname">
								<span>{displayName}</span>
							</div>
						)}
						{accountNumber && (
							<div data-test-id="from-account-details">
								<span>{`${formatSortCode(sortCode)} | ${accountNumber}`}</span>
							</div>
						)}
					</div>
				</FlexColumn>
				<FlexColumn key={`to-${id}`} proportion={2}>
					<div className="u-flex-align-items-center">
						{to.displayName && (
							<div data-test-id="to-displayname">
								<span>{to.displayName}</span>
							</div>
						)}
						{to.accountNumber && (
							<div data-test-id="to-account-details">
								<span>{`${formatSortCode(to.sortCode)} | ${to.accountNumber}`}</span>
							</div>
						)}
					</div>
				</FlexColumn>
				<FlexColumn key={`amount-${id}`} proportion={1}>
					<div className="u-padding-top-2" data-test-id="payment-amount">{`£${amount}`}</div>
				</FlexColumn>
				<FlexColumn key={`reference-${id}`} proportion={2}>
					<div className="u-padding-top-2" data-test-id="payment-reference">
						{reference || reference_high_value}
					</div>
				</FlexColumn>
				<FlexColumn key={`date-${id}`} proportion={1}>
					<div className="u-padding-top-2" data-test-id="payment-date">
						{displayDate(date)}
					</div>
				</FlexColumn>
			</FlexRow>
		);
	};
	return (
		<div>
			{renderHeader && <div className={styles.headerRow}>{renderHeader()}</div>}
			{paymentDetails.map((payment) => (
				<div className={styles.lineStyles} key={payment.id}>
					{renderBody(payment)}
				</div>
			))}
			{renderFooter && <div className={styles.lineStyles}>{renderFooter()}</div>}
		</div>
	);
};

ImportedPaymentTable.defaultProps = {};

ImportedPaymentTable.propTypes = {
	paymentDetails: PropTypes.shape({}).isRequired,
	total: PropTypes.string.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
};

export const contentWrapper = withContent({ content: tableContent })(ImportedPaymentTable);
export default connect(mapState)(contentWrapper);
